const appinfo = {
     NAME:              'ROOBEEK'
    ,VERSION:           '2.19.2-2026-09-16'
}
export default appinfo;
